module.exports = __webpack_public_path__ + "static/notnot-74fcf8bd13bffd57a19a48d280d2029e.png";